import { memo } from 'react';
import Typography from '@mui/material/Typography';

const SidebarSectionTitle = ({ children }) => (
  <Typography
    sx={theme => ({
      textTransform: 'uppercase',
      color: '#9CA3AF',
      fontWeight: 600,
      fontSize: theme.typography.pxToRem(12),
      lineHeight: '30px',
      letterSpacing: '0.5px',
    })}>
    {children}
  </Typography>
);

export default memo(SidebarSectionTitle);
